<script setup lang="ts">
import { useModalPageWrapper } from '@modules/core/components/ModalPageWrapper/composables';
import ModalPageWrapper from '@modules/core/components/ModalPageWrapper/ModalPageWrapper.vue';

import type { IFixedTrackerPaymentsModalPageProps } from './types';
import FixedTrackerPaymentsPage from '../FixedTrackerPaymentsPage/FixedTrackerPaymentsPage.vue';

defineProps<IFixedTrackerPaymentsModalPageProps>();

const { showPageDialog, closePageDialog } = useModalPageWrapper();
</script>

<template>
  <div v-data-qa-auto-id="'FixedTrackerPaymentsModalPage'">
    <ModalPageWrapper
      :show-dialog="showPageDialog"
      :back-to="backTo"
      @hide="closePageDialog"
    >
      <FixedTrackerPaymentsPage
        :edit-history-route="editHistoryRoute"
        :back-from-edit-history-route="backFromEditHistoryRoute"
        :trackers-list-query-key="trackersListQueryKey"
      />
    </ModalPageWrapper>
  </div>
</template>
